import React from "react";

// mui
import { Skeleton } from "@material-ui/lab";
import { Accordion, AccordionSummary, Box, Grid, makeStyles } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const useStyles = makeStyles((theme) => ({
    studentCard: {
        backgroundColor: theme.palette.common.white,
        borderRadius: "6px!important",
        padding: "16px 8px",
        pointerEvents: "none",
    },
}));

export default function Loader() {
    const classes = useStyles();

    return (
        <Box display="flex" flexDirection="column" gridGap="16px">
            {Array.from({ length: 3 }, (_, i) => (
                <Accordion key={i} className={classes.studentCard}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Grid container spacing={1}>
                            <Grid item xs={3}>
                                <Skeleton width={"50%"} />
                                <Skeleton width={"50%"} />
                            </Grid>
                            <Grid item xs={3}>
                                <Skeleton width={"50%"} />
                                <Skeleton width={"50%"} />
                            </Grid>
                            <Grid item xs={3}>
                                <Skeleton width={"50%"} />
                                <Skeleton width={"50%"} />
                            </Grid>
                            <Grid item xs={3}>
                                <Skeleton width={"50%"} />
                                <Skeleton width={"50%"} />
                            </Grid>
                        </Grid>
                    </AccordionSummary>
                </Accordion>
            ))}
        </Box>
    );
}
